import type { Middleware } from 'redux';
import type { AppDispatch } from '@store/types';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { MessageHandlerRegistry, messageHandlerRegistry } from '@reducers/v2/messagesBus/handlerRegistry';

export const createMessageBusDispatchMiddleware = (registry: MessageHandlerRegistry): Middleware =>
  (store) => (next) => (action) => {
    let nextAction = action;

    if (action.type === pushMessage.type) {
      const { key, message } = action.payload;
      if (message.ttl == null) {
        const defaultTtl = registry.getDefaultTtl(message.messageType);
        if (defaultTtl != null) {
          nextAction = { ...action, payload: { key, message: { ...message, ttl: defaultTtl } } };
        }
      }
    }

    const result = next(nextAction);

    if (nextAction.type === pushMessage.type) {
      const { key, message } = nextAction.payload;
      const handlers = registry.getAll(message.messageType);
      for (const handler of handlers) {
        (store.dispatch as AppDispatch)(handler({ key, message }));
      }
    }

    return result;
  };

export const messageBusDispatchMiddleware = createMessageBusDispatchMiddleware(messageHandlerRegistry);
